import { SET_TOKENS } from '../constants/metrics';
import { request } from '../utils/apiHelper';
import { v4 as uuidv4 } from 'uuid';

export type SetTokensInput = {
  idToken: string;
  accessToken: string;
  refreshToken: string;
};

/**
 * The called API will store the tokens from the custom cognito user session.
 *
 * @param apiPath Path to the setTokens API.
 * @param customCognitoUserSession Session data containing idToken, accessToken, refreshToken
 */
export async function setTokens(
  apiPath: string,
  input: SetTokensInput
): Promise<Response | undefined> {
  const response = await request(
    apiPath,
    {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        'X-Correlation-ID': uuidv4(),
      },
      body: JSON.stringify(input),
    },
    { metricNs: SET_TOKENS, treat404AsOk: true }
  );
  if (response.ok === false) return;
  const result = await response.json();
  return result;
}

export default setTokens;
